import { Link } from "react-router-dom"

export function ForbiddenErrorPage () {
  return (
    <div className="dl-page text-center py-5">
      <h1 className="display-3 fw-bold">403</h1>
      <p className="text-white-50 mb-4">Forbidden</p>
      <Link to="/dashboard" className="btn btn-sm btn-outline-secondary">
        <i className="fa fa-arrow-left me-1" />
        Back to Dashboard
      </Link>
    </div>
  )
}

export default ForbiddenErrorPage
